import { useState } from 'react'
import { TrailingEditCSS } from './TrailingEditCSS.styled'
import { onlyDigits } from 'utils/uiUtils_TS'

const INITIAL_VALUE = {
  newTrailingStopValue: '',
  newTrailingStopPercent: '',
  cancelTrailingStopOrder: '',
}

export const TrailingEdit = ({ order = {}, onChange }) => {
  const { trailingStopPercent, trailingStopValue } = order
  const [values, setValues] = useState(INITIAL_VALUE)
  const [isFocused, setFocusInput] = useState({})

  const onInputChange = (e) => {
    const inputName = e.target.name
    const inputValue = onlyDigits(e.target.value)
    setValues((prev) => {
      if (inputName === 'newTrailingStopPercent' && inputValue > 100) return prev
      const newValue = { ...prev, [inputName]: inputValue }
      onChange && onChange(newValue)
      return newValue
    })
  }

    const resetValue = (propName)=> setValues((prev) => {
      const newValue = { ...prev, [propName]: '' }
      onChange && onChange(newValue)
      return newValue
  })

  const onInputClick = (e) => {
    const inputName = e.target.name
    if (inputName === 'newTrailingStopValue') {
      resetValue('newTrailingStopPercent')
      setFocusInput(prev => ({...prev, newTrailingStopValue: true}))
    }
    if (inputName === 'newTrailingStopPercent') {
      resetValue('newTrailingStopValue')
      setFocusInput(prev => ({ ...prev, newTrailingStopPercent: true }))
    }
  }

  const onInputBlur = (e) => {
    const inputName = e.target.name
    const inputValue = onlyDigits(e.target.value)
    if (inputName === 'newTrailingStopValue' && (!inputValue||!values?.newTrailingStopValue)) 
      setFocusInput(prev => ({...prev, newUserStopLossPrice: false}))
    if (inputName === 'newTrailingStopPercent' && (!inputValue || !values?.newTrailingStopPercent)) 
      setFocusInput(prev => ({...prev, newUserStopLossValue: false}))
  }

  const onCheckChange = (e) => {
    const inputName = e.target.name
    const inputCheck = e.target.checked
    setValues((prev) => {
      let prevProps = prev
      if (inputCheck) prevProps = INITIAL_VALUE
      const newValue = { ...prevProps, [inputName]: inputCheck }
      onChange && onChange(newValue)
      return newValue
    })
  }

  return (
    <TrailingEditCSS>
      <div className='show_trailing'>
        <div className='min'>
          <fieldset>
            <span>Close bid with trailing stop</span>
            <div className={`input_wrapper amount`}>
              <input
                type='text'
                name='newTrailingStopValue'
                placeholder={trailingStopValue || 'Amount'}
                value={values?.newTrailingStopValue}
                onChange={onInputChange}
                onClick={onInputClick}
                onFocus={onInputClick}
                onBlur={onInputBlur}
                disabled={values.cancelTrailingStopOrder}
              />
            </div>
          </fieldset>
          <fieldset>
            <strong style={{ color: 'transparent' }}>Loss</strong>
                        <div className={`input_wrapper percentage`}>

              <input
                id = 'trailingPercentageInput'
                type='text'
                name='newTrailingStopPercent'
                className='tpsl_result_data loss'
                placeholder={trailingStopPercent || 'Percentage'}
                value={values?.newTrailingStopPercent}
                onChange={onInputChange}
                onClick={onInputClick}
                onFocus={onInputClick}
                onBlur={onInputBlur}
                disabled={values.cancelTrailingStopOrder}

              />
            </div>
          </fieldset>
        </div>
        <div className='cancel_check'>
          <input
            type='checkbox'
            name='cancelTrailingStopOrder'
            className='max_switch'
            value={values?.cancelTrailingStopOrder}
            checked={values?.cancelTrailingStopOrder}
            onChange={onCheckChange}
          />
          Cancel <strong>Trailing Stop Loss</strong> trigger
        </div>
      </div>
    </TrailingEditCSS>
  )
}
